import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/index.css";

// The server renderer writes per-URL <title>/<meta>/<link> tagged data-seo for crawlers. From
// here on React owns them (PageMeta), so drop the server copies to avoid duplicate tags.
// JSON-LD scripts are untagged and stay.
document.querySelectorAll("head [data-seo]").forEach((element) => element.remove());

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root is missing from index.html");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
